import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LangProvider } from './LangContext';
import HomeScreen from './screens/HomeScreen';
import EventDetailScreen from './screens/EventDetailScreen';
import RedemptionConfirmScreen from './screens/RedemptionConfirmScreen';
import BarcodeDisplayScreen from './screens/BarcodeDisplayScreen';
import SuccessCelebrationScreen from './screens/SuccessCelebrationScreen';
import ErrorScreen from './screens/ErrorScreen';
import MemberBarcodeScreen from './screens/MemberBarcodeScreen';
import MenuScreen from './screens/MenuScreen';
import ProfileScreen from './screens/ProfileScreen';

export default function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <div className="app-shell">
          <Routes>
            <Route path="/"               element={<HomeScreen />} />
            <Route path="/event"          element={<EventDetailScreen />} />
            <Route path="/confirm"        element={<RedemptionConfirmScreen />} />
            <Route path="/barcode"        element={<BarcodeDisplayScreen />} />
            <Route path="/success"        element={<SuccessCelebrationScreen />} />
            <Route path="/error"          element={<ErrorScreen />} />
            <Route path="/barcode-member" element={<MemberBarcodeScreen />} />
            <Route path="/menu"           element={<MenuScreen />} />
            <Route path="/profile"        element={<ProfileScreen />} />
          </Routes>
        </div>
      </BrowserRouter>
    </LangProvider>
  );
}
